import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Panel } from 'react-bootstrap';
import { Column, Row } from '@sm/helpers/simple-flexbox';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';

import PSPIconSingle from '@assets/images/psp_single_wl.png';

import { crudActions } from "@sm/services/crudActions";
import { showAlert } from '@sm/actions';

const PSPsPerformance = () => {
  const history = useHistory();
  const isEnabled = useSelector(state => state.authReducer.providersPerformanceEnabled);

  const [url, setUrl] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isEnabled) {
      history.push('/dashboard');
      return;
    }

    crudActions.get('/v1/psp/performance/auth')
      .then(() => {
        crudActions.get('/v1/psp/performance')
          .then(resp => {
            if (resp) {
              setUrl(resp.url);
            }
          });
      })
      .catch(
        err => {
          if (err && err.message) {
            dispatch(showAlert(true, 'error', err.message));
          }
        }
      );

    return () => {
      Cookies.remove('grafana_session', { domain: '.starmids.com', path: '/' });
      Cookies.remove('grafana_session_expiry', { domain: '.starmids.com', path: '/' });
    };
  }, [dispatch, history, isEnabled]);

  return (
    <Row flexGrow={ 1 } className="module apidata clients" vertical='start'>
      <Column flexGrow={ 1 }>
        <Row className="header" flexGrow={ 1 } horizontal='space-between' vertical='center'>
          <Column>
            <Row horizontal='center' vertical='center' style={ { paddingLeft: 15 } }>
              <img src={ PSPIconSingle } alt="" style={ { marginRight: 10 } } />
                Providers Performance
            </Row>
          </Column>
        </Row>

        <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='start'>
          <Column flexGrow={ 1 } vertical='start' className="panel-block">
            <Panel>
              <Panel.Heading>
                <Panel.Title>
                  PROVIDERS PERFORMANCE
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body>
                <div className="panel-content" style={ { overflow: 'unset' } }>
                  <iframe src={ url } title="Providers Performance" style={ { width: '100%', minHeight: 'calc(100vh - 100px)' } } />
                </div>
              </Panel.Body>
            </Panel>

          </Column>
        </Row>
      </Column>

    </Row>
  );
};

export default PSPsPerformance;